var DualRowPackageWithThermalPadData = require('./dualRowPackageWithThermalPadData.js');
var lib_core = require("lib-core");
var ComponentAttribute = require('./componentAttribute.js');

var SonData = function(position, angle, init) {
    var self = this;
    DualRowPackageWithThermalPadData.apply(this, arguments);

    this.bodyWidthMin.onChange(this, function(val) {
        self.horizontalLeadToLeadSpanMin(val);
    });

    this.bodyWidthMax.onChange(this, function(val) {
        self.horizontalLeadToLeadSpanMax(val);
    });

    if(init) this.padShape(ComponentAttribute.padShapes["Oblong"]);
};

lib_core.inherit(SonData, DualRowPackageWithThermalPadData);
lib_core.JsonParser.registerClass(SonData, "SonData");

module.exports = SonData;
